module.exports = __webpack_public_path__ + "img/shiba-body-level5.e41ab029.png";